export enum MarkUpType {
  Pips,
  Decimal,
  Percentage,
  UsdPerMillion,
}

export namespace MarkUpType {
  let elements = [
    MarkUpType.Pips,
    MarkUpType.Decimal,
    MarkUpType.Percentage,
    MarkUpType.UsdPerMillion,
  ];
  let alias = "com.bcdfx.model.MarkUpType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
